<template>
  <div
    class="grid w-fit max-w-full auto-cols-auto grid-flow-col gap-px divide-x overflow-auto rounded-xl border bg-white lg:max-w-[768px] xl:max-w-full"
  >
    <div class="flex h-[52px] animate-pulse flex-col flex-wrap justify-between px-3 py-3">
      <div class="h-2 w-24 rounded-lg bg-gray-200 dark:bg-gray-400"></div>
      <div class="h-2 w-10 rounded-lg bg-gray-200 dark:bg-gray-400"></div>
    </div>

    <div class="flex h-[52px] animate-pulse flex-col flex-wrap justify-between px-3 py-3">
      <div class="h-2 w-20 rounded-lg bg-gray-200 dark:bg-gray-400"></div>
      <div class="h-2 w-10 rounded-lg bg-gray-200 dark:bg-gray-400"></div>
    </div>

    <div class="flex h-[52px] animate-pulse flex-col flex-wrap justify-between px-3 py-3">
      <div class="h-2 w-32 rounded-lg bg-gray-200 dark:bg-gray-400"></div>
      <div class="h-2 w-8 rounded-lg bg-gray-200 dark:bg-gray-400"></div>
    </div>
  </div>
</template>
